// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.CloseViewReportButton.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import Button from 'share/components/controls/Izenda.Button';
import routeUtils from 'share/utils/Izenda.RouteUtils';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.ReportsConstants';
import QueryStringUtil from 'share/utils/Izenda.QueryStringUtil';
import { SOURCE_PATH_QUERY_KEY } from 'logic/data/Izenda.RouteConstants';
import { get, getOr } from 'lodash/fp';

const CloseViewReportButton = connect()((props: any) => {
  const { store, localization, router, reportType, reportId, disabled, fieldStore } = props;
  const reportListLink =
    store.reportListLink || QueryStringUtil.getValueByKey(get('location.query', props), SOURCE_PATH_QUERY_KEY);

  if (reportListLink) {
    return (
      <BackButton
        onClickFn={router.push.bind(router, reportListLink)}
        localization={localization}
        disabled={disabled}
      />
    );
  }

  const reportInfo = getOr({}, 'masterModel', props.fieldStore);
  let categoryId = null;

  const assignCategoryId = catId => {
    String.isGuidFormat(catId) && catId !== constants.EMPTY_GUID && (categoryId = catId);
  };

  assignCategoryId(reportInfo.categoryId);
  assignCategoryId(reportInfo.subCategoryId);

  const closeReport = function closeReport() {
    const isGlobal = fieldStore.masterModel.isGlobal;
    const reportListUrl = routeUtils.getReportUrl('List', {
      reportType: reportType,
      catId: categoryId,
      reportId: reportId,
      isGlobal: isGlobal
    });
    // Reset selected report
    store.updateReportId(null, null);

    router.push(reportListUrl);
  };

  return (
    <a className="btn btn-primary btn-report-default" disabled={disabled} aria-label="Close" onClick={closeReport}>
      {localization.getText('COMMON_LABEL_CLOSE')}
    </a>
  );
});

const BackButton = (props: any) => {
  const { localization, disabled } = props;
  const labelClose = localization.getText('COMMON_LABEL_CLOSE');
  return (
    <Button className="btn btn-primary btn-report-default" onClick={props.onClickFn} disabled={disabled} aria-label={labelClose}>
      {labelClose}
    </Button>
  );
};

CloseViewReportButton.propTypes = {
  reportType: PropTypes.string.isRequired,
  reportId: PropTypes.string.isRequired,
  categoryId: PropTypes.string
};

export default CloseViewReportButton;



// WEBPACK FOOTER //
// ./ui/modules/Reports/Buttons/Izenda.CloseViewReportButton.js